export default {
  id: 112,
  title: 'Target #112 - Chevron',
  url: 'https://cssbattle.dev/play/112',
  colors: ['#6592CF', '#293D7E'],
  solution:
    '<a><a a><a b><style>body{background:#6592cf}a{position:fixed;top:50;left:75;width:250;height:100;background:#293d7e;clip-path:polygon(0 0,50% 100%,100% 0,85% 0,50% 70%,15% 0)}[a]{top:100}[b]{top:150}</style>',
}
